import React from 'react';
import { observer } from 'mobx-react';
import {
    SideBarSection,
    SideBarSectionWhen
} from '../StepSideBar/StepSideBar.styles';
import WhenButtonGroup from '../Components/WhenButtonGroup';
import ApprovalSwitcher from '../Components/ApprovalSwitcher';
import StaticProTip from '../Components/StaticProTip';
import ActionSelect from '../Components/ActionSelect';
import TemplateSelectButton from '../Components/TemplateSelectButton';
import { useRootStore } from '~/stores/useRootStore';
import AutomationTriggerFilters from '~/components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/AutomationTriggerFilters';

const QuestionnaireSideBar = () => {
    const {
        automationUiStore: {
            selectedStep: { email, fileTemplate, attachmentsCount },
            setSelectedAutomationSidebarScreen
        }
    } = useRootStore();

    return (
        <>
            <SideBarSection>
                <ActionSelect />
                <TemplateSelectButton
                    value={fileTemplate?.title}
                    onButtonClick={() =>
                        setSelectedAutomationSidebarScreen('selectFile')
                    }
                    title="Questionnaire template"
                    type="questionnaire"
                />
            </SideBarSection>
            <SideBarSection>
                <TemplateSelectButton
                    isEmailWithAttachments={email && attachmentsCount > 0}
                    value={email?.title}
                    onButtonClick={() =>
                        setSelectedAutomationSidebarScreen('selectEmail')
                    }
                    title="Send via email"
                    type="email"
                />
            </SideBarSection>
            <SideBarSectionWhen>
                <WhenButtonGroup />
                <AutomationTriggerFilters />
                <ApprovalSwitcher />
            </SideBarSectionWhen>
            <StaticProTip />
        </>
    );
};

export default observer(QuestionnaireSideBar);
